module.exports = __webpack_public_path__ + "img/afternoon-results-1.0a837e84.png";